<template>
  <div class="p-4">
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 14 }"
    >
      <!-- 项目下拉，v-model 指向 form.number -->
      <a-form-model-item prop="number" label="项目">
        <a-select
          v-model="form.number"
          placeholder="请选择项目"
          size="large"
        >
          <a-select-option
            v-for="comm in communities"
            :key="comm.team_id"
            :value="comm.team_id"
          >
            {{ comm.community_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="username" label="用户名">
        <a-input size="large" v-model="form.username" />
      </a-form-model-item>

      <a-form-model-item prop="password" label="密码">
        <a-input-password size="large" v-model="form.password" />
      </a-form-model-item>
    </a-form-model>

    <a-row>
      <a-col :span="14" :offset="5">
        <a-button
          type="primary"
          size="large"
          :loading="isLoading"
          style="width: 100%; margin-top: 24px;"
          @click="login"
        >
          登录
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getToken } from '@/api/user'
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'Login',
  data() {
    return {
      isLoading: false,
      communities: [],
      form: {
        number: '',   // 这里用 number 对应后端的 team_id
        username: '',
        password: ''
      },
      rules: {
        number: [
          { required: true, message: '请选项目', trigger: 'change' }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async fetchCommunities() {
      try {
        const resp = await axios.get('/api/manage_data/communities/')
        this.communities = resp.data || []

        // ✅ 如果还没选项目，并且接口返回了项目列表，就默认选中第一个
        if (!this.form.number && this.communities.length > 0) {
          this.form.number = this.communities[0].team_id
        }
      } catch (err) {
        console.error('获取项目列表失败', err)
        this.$message.error('加载项目列表失败')
      }
    },
    login() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.isLoading = true
        // 此处 this.form.number 就是选中的 team_id，会被当作 number 字段提交
        getToken(this.form)
          .then(data => {
            this.$message.success('登录成功')
            Cookies.set('access', data.access)
            Cookies.set('refresh', data.refresh)
            this.$router.push('/home').then(() => {
              window.location.reload()
            })
          })
          .catch(err => {
            console.error(err)
            this.$message.error('登录失败')
          })
          .finally(() => {
            this.isLoading = false
          })
      })
    }
  },
async created() {
    // 先拉取项目列表
    await this.fetchCommunities()

    // 拉完以后，如果还没重载过，就打标记并重载一次
    if (!sessionStorage.getItem('loginReloaded')) {
      sessionStorage.setItem('loginReloaded', '1')
      window.location.reload()
    } else {
      // 重载过就删掉标记
      sessionStorage.removeItem('loginReloaded')
    }
  }
}
</script>

<style scoped>
.p-4 {
  padding: 16px;
}
</style>
